const PENDIENTE = '0'
const ENCONTRADO = '1'
const NO_ENCONTRADO = '2'
const DIFERENTE_UBICACION = '3'
const DANIADO = '4'

const __dictionary = {
  [PENDIENTE]: { id: PENDIENTE, nombre: 'PENDIENTE', color: 'secondary' },
  [ENCONTRADO]: { id: ENCONTRADO, nombre: 'ENCONTRADO', color: 'success' },
  [NO_ENCONTRADO]: { id: NO_ENCONTRADO, nombre: 'NO ENCONTRADO', color: 'danger' },
  [DIFERENTE_UBICACION]: { id: DIFERENTE_UBICACION, nombre: 'DIFERENTE UBICACIÓN', color: 'warning' },
  [DANIADO]: { id: DANIADO, nombre: 'DAÑADO', color: 'info' }
}

const __array = Object.values(__dictionary)

export default Object.freeze({
  PENDIENTE,
  ENCONTRADO,
  NO_ENCONTRADO,
  DIFERENTE_UBICACION,
  DANIADO,
  __dictionary,
  __array
})
